import { useQuery } from 'react-query';
import { QUERY_KEYS } from 'api/query-keys';
import { useAlert } from 'shared/components/alerts';
import { CompanyPartnersMappedResponse } from 'api/services/workflow/workflow.schema';
import { sharedWorkflowService } from 'api/services';
import { Site } from 'shared/hooks';

export const useGetCompanyPartners = (site: Site, enabled: boolean = true) => {
  const { alertError } = useAlert();

  return useQuery<CompanyPartnersMappedResponse>(
    QUERY_KEYS.workflows(),
    async () => await sharedWorkflowService.getCompanyPartners(site),
    {
      enabled,
      onError: (e) => alertError(e),
    }
  );
};
